module.exports = __webpack_public_path__ + "static/inc5000-0c1c34ebbbb38cf649b0484dc1122045.png";